import { Icon } from '@/common/components/Icon'
import { Button, Modal } from '@/components/ui'
import { cn } from '@/lib/utils'

interface RebuildConfirmationModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

/**
 * Confirmation step for rebuilding a DEFAULT leaderboard from the ledger — a maintenance action
 * (Redis data-loss recovery / backfill), visually distinct from the routine one-click CUSTOM-board
 * regenerate.
 */
export const RebuildConfirmationModal = ({
  open,
  onOpenChange,
  onConfirm,
}: RebuildConfirmationModalProps) => {
  const handleConfirm = () => {
    onConfirm()
    onOpenChange(false)
  }

  return (
    <Modal
      size="sm"
      headerClassName="mb-[37px]"
      contentClassName="p-0 border-2 border-monochrome-120"
      open={open}
      onOpenChange={onOpenChange}
      title={
        <div className="flex items-center gap-2.5">
          <div
            className={cn(
              'h-[44px] w-[44px] rounded-full',
              'bg-monochrome-5 backdrop-blur-md',
              'border-2 border-monochrome-120',
              'flex items-center justify-center',
              'shadow-[0_12px_40px_rgba(0,0,0,0.45)]',
            )}
          >
            <div
              className={cn(
                'h-[40px] w-[40px] rounded-full relative',
                'shadow-[0_0_24px_rgba(136,100%,51%,0.35)]',
                'flex items-center justify-center',
                'text-accent-3',
              )}
            >
              <Icon
                icon="warning-2"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              />
            </div>
          </div>
          <h2 className="text-title-xxs text-monochrome-1 font-bold">
            Rebuild Leaderboard
          </h2>
        </div>
      }
      footerClassName="mt-0 border-t border-monochrome-120 pt-[25px] mt-[25px]"
      footer={
        <div className="flex w-full items-center gap-[15px] justify-end">
          <Button
            onClick={() => onOpenChange(false)}
            variant="secondary"
            className="w-full"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="destructive"
            className="w-full"
          >
            Yes, Rebuild
          </Button>
        </div>
      }
    >
      <div className="text-monochrome-1 text-title-xxs text-center max-w-[500px] mx-auto">
        Rebuild this leaderboard from the ledger? DEFAULT boards are normally
        kept up to date automatically — only rebuild to recover from data loss
        or backfill. Run during low traffic: point awards happening during the
        rebuild may need a second rebuild to be reflected.
      </div>
    </Modal>
  )
}
